<template>
  <div class="flex">
    <div>
      <el-menu
        mode="horizontal"
        class="navbar desktop-menu"
        :background-color="cssStyle.backgroundColor"
        :text-color="cssStyle.textColor"
        :active-text-color="cssStyle.activeTextColor"
      >
        <el-menu-item @click="goTo(navbar.logo.path)">
          <img :src="navbar.logo.src" />
        </el-menu-item>

        <template v-for="(menu, index) in navbar.menus">
          <el-menu-item
            v-if="isEmpty(menu.subMenuGroups)"
            :key="index"
            class="subtitle1"
            @click="goTo(menu.path)"
          >
          <span class="subtitle1">{{ menu.name }}</span>
            
          </el-menu-item>

          <el-submenu v-else :key="'else-submenu-' + index" :index="menu.name">
            <template slot="title">
              <span class="subtitle1">
                {{ menu.name }}
              </span>
            </template>

            <div
              class="subMenuGroups"
              :style="{ width: `${menu.subMenuGroups.length * 250}px` }"
            >
              <el-row>
                <el-col
                  v-for="(subMenuGroup, i) in menu.subMenuGroups"
                  :key="i"
                  :span="24 / menu.subMenuGroups.length"
                  class="subMenuGroup"
                >
                  <div>
                    <div
                      class="subMenuGroupTitle button"
                      :style="{
                        backgroundColor:
                          cssStyle.subMenuGroupColors[i] ||
                          head(cssStyle.subMenuGroupColors),
                      }"
                    >
                      <h5>{{ subMenuGroup.title }}</h5>
                    </div>
                    <div class="subMenuGroupItems button">
                      <div
                        v-for="(item, j) in subMenuGroup.items"
                        :key="j"
                        :style="{
                          color: cssStyle.subMenuGroupColors
                        }"
                        @click="goTo(item.path)"
                      >
                        {{ item.name }}
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-submenu>
        </template>
      </el-menu>
    </div>
    <div class="header-profile-bar" style="width: 402px; margin-left: auto">
      <el-menu
        mode="horizontal"
        class="navbarAction d-flex"
        :background-color="cssStyle.backgroundColor"
        :text-color="cssStyle.textColor"
        :active-text-color="cssStyle.activeTextColor"
        :class="[isRestaurant && 'is-restaurant-options', isRestaurantDetail && 'is-restaurant-options']"
      >
        <el-menu-item
          ref="search"
          class="header-search-bar"
          @click="emitSearchBarActiveHasChange"
        >
          <el-image
            class="image__search"
            :src="images.search.src"
            :fit="'contain'"
          />
        </el-menu-item>
        <el-menu-item class="header-cart-bar" @click="goTo('/shopping-cart')">
          <div
            v-if="((!isShoppingCartEmpty || !getLocalCartProducts) && cartIsNotempty)"
            class="shopping-cart__items__indicator"
          />
          <el-image
            class="image__cart"
            :src="images.cart.src"
            :fit="'contain'"
          />
        </el-menu-item>

        <el-menu-item class="header-user-bar" @click="goTo('/account')">
          <el-image
            class="image__user"
            :src="images.user.src"
            :fit="'contain'"
          />
          <span class="label user ml-3">
            {{ loggedInFirstName }}
          </span>
        </el-menu-item>

        <el-submenu ref="actionBarSubMenu" index="action-bar">
          <div class="actionBar">
            <div style="padding: 5% 1% 5% 6%">
              <LayoutSection
                v-for="(actionBar, i) in navbar.actionBar"
                :key="i"
                size="v100"
                style="padding: 3% 0%"
              >
                <el-col :md="4">
                  <span class="label lang">
                    {{ actionBar.label }}
                  </span>
                </el-col>

                <el-col :md="16" :offset="2">
                  <el-radio-group
                    v-model="actionBar.model"
                    class="header-tax"
                    :title="
                      isActionBarLocked(actionBar.type)
                        ? $t('common.navbar.actionBar.lockedDuringCheckout')
                        : null
                    "
                  >
                    <el-radio
                      v-for="item in head(actionBar.subMenuGroups).items"
                      :key="item.code"
                      :label="item.code"
                      :aria-hidden="false"
                      :disabled="isActionBarLocked(actionBar.type)"
                      @change="
                        emitActionBarValueHasChange(item, actionBar.type)
                      "
                    >
                      <span class="label sub-lang">
                        {{ item.displayLabel }}
                      </span>
                    </el-radio>
                  </el-radio-group>
                </el-col>
              </LayoutSection>

              <!-- A disabled el-radio swallows the click, so the guard in
                   navbar.vue never runs and never gets to explain itself: on
                   desktop the only feedback was a not-allowed cursor. State
                   the reason in the panel instead, where it needs no hover
                   and no click to be read. -->
              <LayoutSection
                v-if="lockedActionBarTypes.length > 0"
                size="v100"
                style="padding: 3% 0% 0%"
              >
                <el-col :md="22" :offset="2">
                  <span class="label actionBar__lockedNote">
                    {{ $t("common.navbar.actionBar.lockedDuringCheckout") }}
                  </span>
                </el-col>
              </LayoutSection>
            </div>
          </div>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import { get, head, isEmpty, keyBy } from "@/utils/lodash";

import imgSearch from "@/assets/images/navbar/navbar-search.png";
import imgCart from "@/assets/images/navbar/navbar-cart.svg";
import imgUser from "@/assets/images/navbar/navbar-user.svg";

import LayoutSection from "@/components/layout/layout-section.vue";

import cssVariables from "@/assets/variables.scss";
import Store from '@/store';
import userApi from "@/api/user";
// import goTo from "../../mixins/goTo";

export default {
  // mixins: [goTo],
  components: {
    LayoutSection,
  },
  props: {
    navbar: {
      type: Object,
      default: () => {},
    },
    selectedActionValues: {
      type: Object,
      default: () => {},
    },
    // Action-bar types the current route forbids changing (see navbar.vue's
    // lockedActionBarTypes — market and tax during checkout).
    lockedActionBarTypes: {
      type: Array,
      default: () => [],
    },
    cssStyle: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      activeName: "first",
      images: {
        search: {
          src: imgSearch,
        },
        cart: {
          src: imgCart,
        },
        user: {
          src: imgUser,
        },
      },
      cartIsNotempty: true,
      countryCode: localStorage.getItem('countryCode') || 'QC'
    };
  },
  computed: {
    ...mapState("user", ["user"]),
    ...mapGetters("user", ["isLoggedIn"]),
    ...mapGetters("shoppingCart", ["isShoppingCartEmpty", "getLocalCartProducts"]),
    isRestaurant(){
      return this.$route && this.$route.fullPath.indexOf('inventory=') > -1 ? true : false;
    },
    isRestaurantDetail() {
      return this.$route && this.$route.fullPath.indexOf('productType=') > -1  ? true : false;
    },
    loggedInFirstName() {
      const firstName = get(this.user, "firstName");
      const getUser = JSON.parse(localStorage.getItem("user"));
      
      return this.isLoggedIn && firstName ? firstName : getUser ? getUser.user.firstName : '';
    },

    actionBtnValue() {
      const indexActionBarLanguageItemsByCode = keyBy(
        head(this.$i18n.t("common.navbar.actionBar.language.subMenuGroups"))
          .items,
        "code"
      );
      const indexActionBarCountryItemsByCode = keyBy(
        head(this.$i18n.t("common.navbar.actionBar.country.subMenuGroups"))
          .items,
        "code"
      );
      const indexActionBarTaxItemsByCode = keyBy(
        head(this.$i18n.t("common.navbar.actionBar.tax.subMenuGroups")).items,
        "code"
      );

      return [
        indexActionBarLanguageItemsByCode[this.selectedActionValues.language]
          .displayCode,
        indexActionBarCountryItemsByCode[this.selectedActionValues.country]
          .displayCode,
        indexActionBarTaxItemsByCode[this.selectedActionValues.tax].displayCode,
        "",
      ].join(" | ");
    },
  },
  watch: {
    actionBtnValue() {
      const span = document.getElementById("btnActionBar");
      span.after(span.children[0]);
      span.innerHTML = this.actionBtnValue;
      span.appendChild(span.parentNode.children[1]);
    },
    // $route(val){
    //   const span = document.getElementById('btnActionBar');
    //   if(span){
    //     let isRestaurant = val && val.fullPath.indexOf('inventory=');
    //     let isRestaurantDetail = val && val.fullPath.indexOf('productType=');
    //      span.style.cssText +=
    //       `border: 1px solid ${isRestaurant > -1 || isRestaurantDetail > -1 ? '#916203' : cssVariables.colorPrimaryLight}; border-radius:100px; padding: 6px 8px; color: ${cssVariables.colorBackground}` +
    //       `!important; background-color: ${isRestaurant > -1 || isRestaurantDetail > -1 ? '#916203' : cssVariables.colorPrimaryLight}; letter-spacing: 1.25px;`;
    //   }
    // },
    $route() {
      const countryCode = localStorage.getItem('countryCode');
      const cartProductsQC = localStorage.getItem('cartProductsQC');
      const cartProductsON = localStorage.getItem('cartProductsON');
      if(this.isLoggedIn == false){
        if(countryCode == "QC" && (cartProductsQC == null || cartProductsQC == 'null')){
          this.cartIsNotempty = false;
        }else if(countryCode == "ON" && (cartProductsON == null || cartProductsON == 'null')){
          this.cartIsNotempty = false;
        }else{
          this.cartIsNotempty = true;
        }
      }else{
        this.cartIsNotempty = true;
      }
    },
    countryCode(){
      const countryCode = localStorage.getItem('countryCode');
      const cartProductsQC = localStorage.getItem('cartProductsQC');
      const cartProductsON = localStorage.getItem('cartProductsON');
      if(this.isLoggedIn == false){
        if(countryCode == "QC" && (cartProductsQC == null || cartProductsQC == 'null')){
          this.cartIsNotempty = false;
        }else if(countryCode == "ON" && (cartProductsON == null || cartProductsON == 'null')){
          this.cartIsNotempty = false;
        }else{
          this.cartIsNotempty = true;
        }
      }else{
        this.cartIsNotempty = true;
      }
    }
  },
  mounted() {
    this.createActionBarLayout();
    this.$root.$on("chancountryCode", (countryCode) => {
      this.countryCode = countryCode;
    });
  },
  methods: {
    ...mapActions("user", ["logout"]),
    ...mapActions("shoppingCart", ["updateShoppingCart", "fetchShoppingCart"]),
    ...mapActions("product", ["fetchProductsByPuid"]),
    goTo (path, condition = true) {
      const getCountryCode = localStorage.getItem('actualCountryCode');
      if(this.isLoggedIn == true && getCountryCode == 'QC' && path == '/products??inventory=STORE_TORONTO') {
         localStorage.setItem("countryCode", 'ON');
        this.$store.dispatch('configuration/setActionBarCountry', { country: { code: 'ON' } });
        this.handleLogout();
        this.$router.push('products?inventory=STORE_TORONTO');
        return;
      }
      if (this.isLoggedIn == true && getCountryCode == 'ON' && path == '/products??inventory=STORE_MTL') {
        localStorage.setItem("countryCode", 'QC');
        this.$store.dispatch('configuration/setActionBarCountry', { country: { code: 'QC' } });
        this.handleLogout();
        this.$router.push('products?inventory=STORE_MTL');
        return;
      }
      const countryCode = localStorage.getItem('countryCode');
      if(this.isLoggedIn == false && countryCode == 'ON' && path == '/products??inventory=STORE_MTL'){
        localStorage.setItem("countryCode", 'QC');
        this.$store.dispatch('configuration/setActionBarCountry', { country: { code: 'QC' } });
        const accessToken = sessionStorage.getItem("access-token");
        const userRaw = sessionStorage.getItem("user");
        const user = userRaw ? JSON.parse(userRaw) : null;
        const customer = sessionStorage.getItem("customer");
        if (user && accessToken) {
          localStorage.setItem('user', JSON.stringify(user));
          localStorage.setItem('customer', customer);
          localStorage.setItem('access-token', accessToken);
          localStorage.setItem('token', accessToken)
          this.updateShoppingCartUser().then(() => {
            if(this.user && this.user.passwordExpired == true){
              this.$router.push('/reset-password');
            }
          });
          const storedUser = localStorage.getItem('user');
          if (storedUser) {
            userApi.findById(JSON.parse(storedUser).user.id).then((u) => {
              Store.dispatch("user/setUserProfile", u);
            });
          }
        }
        this.$router.push('/products?inventory=STORE_MTL');
        return;
      }

      if(this.isLoggedIn == false && countryCode == 'QC' && path == '/products??inventory=STORE_TORONTO'){
        localStorage.setItem("countryCode", 'ON');
        this.$store.dispatch('configuration/setActionBarCountry', { country: { code: 'ON' } });
      }

      if (condition) {
        this.$router.push(path).then(() => {});
      }
    },
    isEmpty(array) {
      return isEmpty(array);
    },
    head(array) {
      return head(array);
    },
    isActionBarLocked(type) {
      return this.lockedActionBarTypes.indexOf(type) > -1;
    },
    emitActionBarValueHasChange(value, type) {
      if (this.isActionBarLocked(type)) {
        return;
      }

      this.$emit("action-bar-value-has-change", {
        value,
        type,
      });
    },
    emitSearchBarActiveHasChange() {
      this.$emit("search-bar-active-has-change");
    },
    handleLogout() {
      Store.dispatch('user/logout');
      Store.dispatch('shoppingCart/emptyShoppingCart');
      Store.dispatch('user/createTempUser');
      
      this.logout();
      // this.$router.push("/login");
    },
    createActionBarLayout() {
      const span = document.createElement("span");
      span.id = "btnActionBar";
      span.className = "label";
      span.style.cssText +=
        `border: 1px solid ${cssVariables.colorPrimaryLight}; border-radius:100px; padding: 6px 8px; color: ${cssVariables.colorBackground}` +
        `!important; background-color: ${cssVariables.colorPrimaryLight}; letter-spacing: 1.25px;`;
      span.innerHTML = this.actionBtnValue;
      this.$refs.actionBarSubMenu.$el.children[0].children[0].before(span);
      this.$refs.actionBarSubMenu.$el.children[0].children[1].style.cssText =
        "margin-left: 0;";
      span.appendChild(this.$refs.actionBarSubMenu.$el.children[0].children[1]);
    },
    updateShoppingCartUser() {
      const vm = this;
      const getId = JSON.parse(sessionStorage.getItem("user"));
      const user = {
        id: getId?.id,
      };
      if (getId) {
        return Promise.resolve(
          this.fetchShoppingCart({
            id: getId.id,
          })
            .then(() => {
              const shoppingCart = {
                lockVersion: vm.shoppingCart.lockVersion,
                user,
                products: vm.shoppingCart.products,
              };
              const cartId = user.id
              vm.updateShoppingCart({
                id: cartId,
                shoppingCart,
              });
            })
            .catch((error) => {
              console.log(error);
            })
        );
      }
      return Promise.resolve();
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables.scss";

img {
  width: 108px;
  height: 34px;
}

i {
  color: $color-on-primary;
}

.navbarAction {
  float: right;
  flex-wrap: nowrap;
}

.subMenuGroups,
.actionBar {
  background-color: white !important;
}

.actionBar {
  width: 360px;
}

.subMenuGroup {
  padding: 4%;

  & .subMenuGroupTitle {
    padding: 5px 0px 5px 20px;
    color: $color-on-primary;
  }

  & .subMenuGroupItems {
    padding-top: 10px;

    & div {
      cursor: pointer;
      padding: 5%;
      padding-left: 20px;
    }

    & div:hover {
      text-decoration: underline;
    }
  }
}
.shopping-cart__items__indicator {
  width: 8px;
  height: 8px;
  background-color: #70b603;
  border-radius: 20px;
  position: absolute;
  top: 14px;
  z-index: 9999;
  left: 16px;
}
.image__search {
  width: 17px;
  height: 17px;
}
.image__cart {
  width: 20px;
  height: 17px;
}
.image__user {
  width: 20px;
  height: 20px;
}
.user {
  color: $color-on-primary;
}
.lang {
  font-weight: bold;
  color: #000;
  font-size: 14px !important;
}
.sub-lang {
  color: #000;
  font-size: 14px !important;
}
.actionBar__lockedNote {
  display: block;
  color: #6b6b6b;
  font-size: 12px !important;
  line-height: 1.4;
}
.header-tax {
  .el-radio {
    min-width: 84px;
  }
}
</style>
